import React from 'react';
import classnames from 'classnames';
import { withTheme } from '@ifit/themes/withTheme';
import styles from './index.module.scss';

export interface IProps {
  className?: string;
  description: string;
  imageUrl: string;
  leadLine: string;
  onClick: React.MouseEventHandler<HTMLAnchorElement>;
  themeClass?: string;
  title: string;
}

const CardMarketing = ({
  className,
  description,
  imageUrl,
  leadLine,
  onClick,
  themeClass,
  title,
  ...rest
}: IProps) => {
  return (
    <a
      href="#"
      onClick={onClick}
      className={classnames(
        styles['mp-card-marketing'],
        'mp-card-marketing',
        themeClass,
        className
      )}
      data-testid="mp-card-marketing"
      {...rest}
    >
      <article className={styles.article}>
        <div className={styles['image-container']}>
          <img
            src={imageUrl}
            alt=""
            className={classnames(styles.image, 'mp-card-marketing-image')}
          />
        </div>

        <div
          className={classnames(
            styles['details-container'],
            'mp-card-marketing-details-container'
          )}
        >
          <header className={styles.header}>
            <p className={styles['lead-line']}>{leadLine}</p>
            <h2 className={styles.title}>{title}</h2>
          </header>

          <p className={styles.description}>{description}</p>
        </div>
      </article>
    </a>
  );
};

export default withTheme(CardMarketing);
